"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.availableKpiTypeByDevice = exports.isAtmosphereDevice = void 0;
var deviceAtmosphereEnabledKpi_type_1 = require("./deviceAtmosphereEnabledKpi.type");
var brand_type_1 = require("./brand.type");
var model_type_1 = require("./model.type");
var DEFAULT_KPIS = [deviceAtmosphereEnabledKpi_type_1.KpiAtmosphereTypes.CO2, deviceAtmosphereEnabledKpi_type_1.KpiAtmosphereTypes.HUMIDITY, deviceAtmosphereEnabledKpi_type_1.KpiAtmosphereTypes.TEMPERATURE];
var DEVICE_KPIS = (_a = {},
    _a[brand_type_1.DeviceModelId.NANOSENSE_E4000NG] = [deviceAtmosphereEnabledKpi_type_1.KpiAtmosphereTypes.LUMINOSITY],
    _a[brand_type_1.DeviceModelId.ELSYS_ERSCO2] = [deviceAtmosphereEnabledKpi_type_1.KpiAtmosphereTypes.COV],
    _a);
var isAtmosphereDevice = function (device) { var _a; return (((_a = device === null || device === void 0 ? void 0 : device.model) === null || _a === void 0 ? void 0 : _a.application) || []).includes(model_type_1.Application.AIR_QUALITY); };
exports.isAtmosphereDevice = isAtmosphereDevice;
var availableKpiTypeByDevice = function (device) { return __spreadArray(__spreadArray([], __read(DEFAULT_KPIS), false), __read((DEVICE_KPIS[device.modelId] || [])), false); };
exports.availableKpiTypeByDevice = availableKpiTypeByDevice;
